import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Login } from "../../pages/auth/login/login";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { useContext, useEffect } from "react";
import { UseCasesContext } from "../../../context/useCases";
import { ChangePass } from "../../pages/users/change-pass";
import { UserAdd } from "../../pages/users/add";
import { UserList } from "../../pages/users/list";
import { LandingList } from "../../pages/landings/list";
import { LandingAdd } from "../../pages/landings/add";
import { UploadLandingList } from "../../pages/upload-photo/landings";
import { UploadMonthsList } from "../../pages/upload-photo/months";
import { UploadPage } from "../../pages/upload-photo/upload";

export const RouterComponent = () => {
  let useCases = useContext(UseCasesContext)

  const login = useTypedSelector(({ login }) => {
    return login
  })

  useEffect(() => {
    useCases?.authUseCase.CheckAuthorization()
    setInterval(()=>{
      useCases?.authUseCase.CheckAuthorization()
    },10000)
  }, [])
 
  
  return (<Router basename="/">
    <Routes>
      {login?.authorized ? <>
          <Route path="/user/password/:id" element={<ChangePass />} />
          <Route path="/user/edit/:id" element={<UserAdd />} />
          <Route path="/user/add" element={<UserAdd />} />
          <Route path="/user" element={<UserList />} />


          <Route path="/upload/:landingId/:year/:month" element={<UploadPage />} />

          <Route path="/landing/edit/:id" element={<LandingAdd />} />
          <Route path="/landing/add" element={<LandingAdd />} />
          <Route path="/landing" element={<LandingList />} />

          <Route path="/upload-task/paths/:id" element={<UploadMonthsList />} />
          <Route path="*" element={<UploadLandingList />} />
      </> : <>
        <Route path="*" element={<Login />} />
      </>}
    </Routes>
  </Router>
  )
}